import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { pushDataLayerEvent } from './utils.js'

const PageView = () => {
  const location = useLocation()

  useEffect(() => {
    const { pathname } = location

    const pageTitle =
      pathname === '/'
        ? 'Home'
        : pathname
            .substring(1)
            .split('/')
            .map(
              (segment) => segment.charAt(0).toUpperCase() + segment.slice(1)
            )
            .join(' ')

    pushDataLayerEvent('page_view', 'navigation', pathname, pageTitle)
  }, [location])

  return null
}

export default PageView
